import { url } from "../../config";
import { useHistory } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import general from "../../general";
import { useInterval, useLocalStorageState } from "ahooks";
import useActiveState from "../../lib/useActiveState";
import Dialog from "../../lib/Dialog";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { behaviorTrigger } from "../../utils/trigger";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import { useLogin } from "../../lib/LoginContext";

// 手机号、验证码登录
export default () => {
  const history = useHistory();
  const [app] = useActiveState("app");
  const { aplus_queue } = window;
  const [agreement, setAgreement] = useState(false);
  const [loging, setLoging] = useState();
  const phoneRef = useRef(null);
  const [phone, setPhone] = useLocalStorageState("phone", {
    defaultValue: "",
  });
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState([]);

  useEffect(() => {
    localStorage.setItem("userPhoneLoginMobile", phone);
  });

  const { setShowLogin, setIsFromLogin } = useLogin();

  // 下拉框选择用户/手机号登录设置密码后
  const finalLogin = async (user) => {
    setUser(user);
    if (loging) {
      return;
    }
    setLoging(true);
    Dialog.loading();
    await general.axios
      .post("/v3/finalCellularLogin", {
        username: user.username,
        token: user.token,
        password,
      })
      .finally(() => {
        setLoging(false);
        Dialog.close();
      })
      .then(async (res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          setLoging(false);
          Dialog.error(status.error_desc);
          return;
        }
        localStorage.setItem("token", data.token);
        localStorage.setItem("user_id", data.id);
        // localStorage.setItem("username", data.username);
        aplus_queue.push({
          action: "aplus.record",
          arguments: [
            "login",
            "login",
            {
              type: "oneClickLogin",
              agent: localStorage.getItem("agent"),
              username: data.username,
            },
          ],
        });

        Dialog.info("登录成功");

        await getUserInfo();
        getPopup(data);

        setShowLogin(false);
        document.body.style.overflow = "";

        // 是老用户  并且为新人福利登录 返回首页
        if (data.is_new_user === 0 && sessionStorage.getItem("isHaveBack")) {
          history.replace("/");
          window.location.reload();
        } else {
          general.goBack(true);
        }
      })
      .catch((err) => {
        axios.post(`${url}/v3/log`, { type: "finalCellularLogin", err: err });
        Dialog.error("finalCellularLogin " + err.message);
      });
  };

  const codeRef = useRef();
  const [code, setCode] = useState("");
  const [codIng, setCodIng] = useState(false);
  const [codeTime, setCodeTime] = useState(0);
  useInterval(() => {
    if (codeTime) {
      setCodeTime(codeTime - 1);
    }
  }, 1000);

  // 手机号验证码输入完成  点击按钮登录
  const loginCode = async () => {
    if (loging) {
      return;
    }
    if (!phone) {
      Dialog.error("请输入手机号");
      return;
    }
    if (!/^\d{11}$/.test(phone)) {
      Dialog.error("手机号码格式不正确");
      return;
    }

    if (!code) {
      Dialog.error("请输入验证码");
      return;
    }

    if (!agreement) {
      Dialog.error(
        <div>
          登录前请阅读并同意
          <br />
          以下用户协议和隐私政策
        </div>
      );
      return;
    }

    setLoging(true);
    Dialog.loading();

    await general.axios
      .post("/v3/user/user/verificaCodeLoginGrpc", {
        phone_number: phone,
        code,
        password,
      })
      .finally(() => {
        setLoging(false);
        Dialog.close();
      })
      .then(async (res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          setLoging(false);
          Dialog.error(status.error_desc);
          return;
        }

        let users = data.users;
        if (users.length === 1) {
          if (data.type == "register" && localStorage.getItem("tgm_uuid")) {
            behaviorTrigger("register", {
              username: users[0].username,
            });
          }

          if (!users[0].isSetPassword) {
            setIsPassword(true);
            setUser(users[0]);
            return;
          }
          localStorage.setItem("token", users[0].token);
          localStorage.setItem("user_id", users[0].id);
          // localStorage.setItem("username", users[0].username);
          aplus_queue.push({
            action: "aplus.record",
            arguments: [
              "login",
              "login",
              {
                type: "code",
                agent: localStorage.getItem("agent"),
                username: users[0].username,
              },
            ],
          });

          Dialog.info("登录成功");

          await getUserInfo();
          getPopup(users[0]);

          setShowLogin(false);
          document.body.style.overflow = "";

          // 是老用户  并且为新人福利登录 返回首页
          if (
            users[0].is_new_user === 0 &&
            sessionStorage.getItem("isHaveBack")
          ) {
            history.replace("/");
            window.location.reload();
          } else {
            // 新人账号并且为竞价渠道号
            if (
              users[0].type == "register" &&
              sessionStorage.getItem("jjAgentShow")
            ) {
              return;
            }

            window.location.reload();
          }
        } else {
          setUsers(users);
        }
      })
      .catch((err) => {
        axios.post(`${url}/v3/log`, { type: "verificaCodeLogin", err: err });
        Dialog.error("verificaCodeLogin " + err.message);
      });
  };

  // 获取用户信息
  const getUserInfo = async () => {
    await general.axios
      .post("/v3/user/user/getMemberInfo")
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          if (status.error_code == 1016) {
            localStorage.removeItem("user_id");
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            localStorage.removeItem("token");
          } else {
            Dialog.error(status.error_desc);
          }
        } else {
          localStorage.setItem("username", data.member_info.member_name);
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  // 获取弹窗数据
  const getPopup = (newuserData) => {
    general.axios.post("/v3/movable/popup/popup").then(({ data: resData }) => {
      console.log("右下角悬浮球--------", resData);
      let { status, data } = resData;
      if (status.succeed) {
        // 新人账号并且为竞价渠道号，且为新人福利弹窗，则跳转新人福利页面
        if (
          newuserData?.type == "register" &&
          sessionStorage.getItem("jjAgentShow") &&
          data.title == "新人见面礼"
        ) {
          let url = `${data?.jump_value}?origin=react&agent=${
            app.agent
          }&brand=${app.brand}&username=${localStorage.getItem(
            "username"
          )}&token=${localStorage.getItem("token")}`;
          console.log("defuhuiehfieuahfiuje-----");

          Dialog.success("登录成功", () =>
            history.replace(
              `/iframe?url=${encodeURIComponent(url)}&title=新人见面礼&gohome=1`
            )
          );

          return;
        }

        sessionStorage.setItem(
          "popupData",
          JSON.stringify({
            ...data,
            route: data?.jump_value,
          })
        );
      }
    });
  };

  const [isPassword, setIsPassword] = useState();
  const [isPlaintext, setIsPlaintext] = useState(false);
  const [password, setPassword] = useState();

  let clickCount = 0;

  const encodeAndHash = (value) => {
    // Base64 编码
    const base64Encoded = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(value)
    );

    // console.log(base64Encoded);

    // MD5 加密
    const md5Hash = CryptoJS.MD5(base64Encoded).toString(CryptoJS.enc.Hex);

    console.log(md5Hash);

    return md5Hash;
  };

  // 阿里云验证
  let captcha;

  const getInstance = (instance) => {
    captcha = instance;
  };

  let reqNum = 0;
  const captchaVerifyCallback = async (captchaVerifyParam) => {
    // 1.向后端发起业务请求，获取验证码验证结果和业务结果
    // console.log('阿里云滑动验证---', captchaVerifyParam);

    if (codIng || codeTime) {
      return;
    }

    let resCode = 0;

    setCodIng(true);
    Dialog.loading();

    let mobile = localStorage.getItem("userPhoneLoginMobile") || "";
    console.log("要传递的数据---", mobile);

    let str = `08${mobile}${dayjs().unix().toString()}`;
    // console.log(str);

    await general.axios
      .post("/v3/base/tool/getVerifyCode", {
        mobile: mobile,
        code: "code",
        type: "08",
        captchaVerifyParam,
        time: dayjs().unix().toString(),
        sign: encodeAndHash(str),
      })
      .finally(() => {
        setCodIng(false);
        Dialog.close();
      })
      .then((res) => {
        console.log("手机号登录", res);

        if (res.data) {
          let { status } = res.data;
          if (!status.succeed) {
            if (reqNum === 0) {
              reqNum = 1;
              return;
            }
            Dialog.error(status.error_desc);
            return;
          } else {
            setCodeTime(60);

            resCode = 1;
          }
        } else {
          Dialog.error("获取验证码失败，请重试");
        }
      })
      .catch((err) => {
        axios.post(`${url}/v3/log`, { type: "getVerifyCode", err: err });
        Dialog.error("getVerifyCode " + err.message);
      });

    return {
      captchaResult: resCode === 1 ? true : false,
      bizResult: resCode === 1 ? true : false,
    };
  };
  // 验证通过后调用
  const onBizResultCallback = () => {
    console.log("onBizResultCallback");
  };

  useEffect(() => {
    window.initAliyunCaptcha({
      SceneId: "1987jrzc", // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: "jjw9bz", // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: "popup", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: "#captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: "#captcha-button", // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
      getInstance: getInstance, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 320,
        height: 40,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    });
    return () => {
      // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
      document.getElementById("aliyunCaptcha-mask")?.remove();
      document.getElementById("aliyunCaptcha-window-popup")?.remove();
    };
  }, []);

  return (
    <div className="account-phonelogin">
      <div className="phonelogin-body">
        <div className="input">
          <div className="input-content">
            <div className="input-content-left">
              <span className="input-content-left-prefix">手机号</span>

              <input
                name="phone"
                type="tel"
                value={phone}
                placeholder="请输入手机号"
                onChange={(e) => {
                  // console.log("手机号输入变化---", e.target.value);

                  localStorage.setItem(
                    "userPhoneLoginMobile",
                    e.target.value.trim()
                  );
                  setPhone(e.target.value.trim());

                  //console.log("手机号变化赋值---", phone);
                }}
                ref={phoneRef}
                onMouseDown={() => {
                  clickCount++;
                  if (clickCount > 2) {
                    Dialog.info(
                      <div>
                        若遇到iOS系统键盘问题，请
                        <br />
                        重启手机或我的-&gt;联系客服
                      </div>
                    );
                    clickCount = 0;
                  }
                }}
              />
            </div>

            {phone ? (
              <CloseCircleOutlined
                className="clear"
                style={{ marginRight: 0 }}
                onClick={() => {
                  localStorage.setItem("userPhoneLoginMobile", "");
                  setPhone("");
                }}
              />
            ) : null}
          </div>
        </div>

        <div className="captcha-a">
          <div id="captcha-element"></div>
        </div>

        <div className="input code">
          <div className="input-content">
            <div className="input-content-left">
              <span className="input-content-left-prefix">验证码</span>

              <input
                name="code"
                type="tel"
                value={code}
                placeholder="请输入验证码"
                onChange={(e) => setCode(e.target.value.trim().slice(0, 6))}
                autoComplete="off"
                ref={codeRef}
                onMouseDown={() => {
                  clickCount++;
                  if (clickCount > 2) {
                    Dialog.info(
                      <div>
                        若遇到iOS系统键盘问题，请
                        <br />
                        重启手机或我的-&gt;联系客服
                      </div>
                    );
                    clickCount = 0;
                  }
                }}
              />

              {code ? (
                <CloseCircleOutlined
                  className="clear"
                  onClick={() => setCode("")}
                />
              ) : null}
            </div>

            <div style={{ display: "none" }} id="captcha-button"></div>
            <div
              className={"code-btn " + (codIng || codeTime ? "disable" : "")}
              onClick={() => {
                if (!phone) {
                  Dialog.error("请输入手机号");
                  return;
                }
                if (codIng || codeTime) {
                  return;
                } else {
                  const button = document.getElementById("captcha-button");
                  button.onclick();
                }
              }}
            >
              {codIng ? (
                "发送中"
              ) : codeTime ? (
                <>
                  <p className="code-time">{codeTime}</p>秒后重试
                </>
              ) : (
                "获取验证码"
              )}
            </div>
          </div>
        </div>

        <div className="tips">未注册用户可直接注册登录</div>

        <div className={"btn " + (loging ? "disable" : "")} onClick={loginCode}>
          登录
        </div>
      </div>

      {users.length > 0 ? (
        <div className="phonelogin-users">
          <div className="mask" onClick={() => setUsers([])} />
          <div className="body">
            <div className="title">选择用户</div>
            <div className="users">
              {users.map((user, index) => (
                <div
                  key={index}
                  className="user"
                  onClick={() => finalLogin(user)}
                >
                  {user.username}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}

      {isPassword ? (
        <div className="phonelogin-password">
          <div className="body">
            <div className="title">请设置密码</div>

            <div className="main-content">
              <input
                type={isPlaintext ? "text" : "password"}
                placeholder="输入密码"
                value={password}
                onChange={(e) => setPassword(e.target.value.trim())}
                onMouseDown={() => {
                  clickCount++;
                  if (clickCount > 2) {
                    Dialog.info(
                      <div>
                        若遇到iOS系统键盘问题，请
                        <br />
                        重启手机或我的-&gt;联系客服
                      </div>
                    );
                    clickCount = 0;
                  }
                }}
              />

              <div className="eye" onClick={() => setIsPlaintext(!isPlaintext)}>
                {isPlaintext ? (
                  <img src="/resources/account/hidden.png" />
                ) : (
                  <img src="/resources/account/show.png" />
                )}
              </div>
            </div>

            <div
              className={"btn " + (!password ? "disable" : "")}
              onClick={() => {
                if (password) {
                  if (password.length < 6 || password.length > 16) {
                    Dialog.error("密码必须是6-16位");
                    return;
                  }
                  finalLogin(user);
                }
              }}
            >
              提交
            </div>
          </div>
        </div>
      ) : null}

      <div className="account-agreement" style={{ marginTop: "67px" }}>
        {agreement ? (
          <CheckCircleOutlined className="checked" />
        ) : (
          <div className="unchecked" onClick={() => setAgreement(true)}></div>
        )}
        我已阅读并同意
        <div
          className="agreement-link"
          onClick={() => {
            setIsFromLogin(true);

            setTimeout(() => {
              history.push(
                "/iframe?url=" + url + "/userAgreement&title=用户协议"
              );
            }, 100);
          }}
        >
          《用户协议》
        </div>
        、
        <div
          className="agreement-link"
          onClick={() => {
            setIsFromLogin(true);

            setTimeout(() => {
              history.push(
                "/iframe?url=" + url + "/privacyPolicy&title=隐私政策"
              );
            }, 100);
          }}
        >
          《隐私政策》
        </div>
      </div>
    </div>
  );
};
